// extracted by mini-css-extract-plugin
export default {"titleWrapper":"index_titleWrapper__g42Zh","section":"index_section__Pq+WJ","bold":"index_bold__dLkcj"};